
import {
  apiOrderMealLists,
  apiSetMealDetail,
  apiOrderMealAdd,
  apiOrderMealEdit,
  apiSetMealSwitchStatus,
  apiOrderMealDelete,
} from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
@Component({
  components: {
    lsPagination,
    LsDialog,
    DatePicker,
  },
})
export default class SetMealList extends Vue {
  /** S Data **/

  apiOrderMealLists = apiOrderMealLists;

  pager: RequestPaging = new RequestPaging();

  searchObj: Object = {
    status: "",
    shop_info: "",
    start_time: "",
    end_time: "",
    type: 1,
  };
  id = 0;
  form: any = {
    number: "", //
    price: "",
    status: 1,
    sort: 1,
    type: 1,
  };
  formDialogVisible = false;
  // 表单校验
  rules = {
    name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
    description: [
      { required: true, message: "请输入套餐说明", trigger: "blur" },
    ],
    number: [{ required: true, message: "请输入订单数", trigger: "blur" }],
    price: [{ required: true, message: "请输入订单单价", trigger: "blur" }],
  };
  /** E Data **/

  /** S Methods **/
  // 获取列表
  getLists(): void {
    this.pager.request({
      callback: apiOrderMealLists,
      params: {
        ...this.searchObj,
      },
    });
  }
  // 点击使用记录
  handleUseRecord() {
    this.$router.push({
      path: "/shop/order_meal/use_record",
    });
  }
  handleAdd() {
    this.id = 0;
    this.form = {
      name: "",
      description: "",
      number: "", //
      price: "",
      status: 1,
      sort: 1,
      type: 1,
    };
    this.formDialogVisible = true;
  }
  // 点击编辑
  async handleEdit(value: any) {
    this.id = value.id;
    this.form = {
      name: value.name, //
      description: value.description,
      number: value.number, //
      price: value.price,
      status: value.status,
      sort: value.sort,
    };
    this.formDialogVisible = true;
  }

  // 修改状态
  async shopSwitchStatusEdit(status: number, id: number): Promise<void> {
    await apiSetMealSwitchStatus({ id, status: status });
    this.getLists();
  }

  // 删除
  async onSetMealDelete(row: any): Promise<void> {
    await apiOrderMealDelete({ id: row.id });
    this.getLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getLists();
  }

  // 添加
  async handleSetMealAdd(): Promise<void> {
    await apiOrderMealAdd({ ...this.form });
    this.getLists();
  }

  //
  async handleSetMealEdit(): Promise<void> {
    await apiOrderMealEdit({ ...this.form, id: this.id });
    this.getLists();
  }

  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement;
    refs.validate((valid: boolean): any => {
      if (!valid) return;

      if (!this.id) {
        this.handleSetMealAdd();
      } else {
        this.handleSetMealEdit();
      }
      this.formDialogVisible = false;
    });
  }

  /** E Methods **/

  /** S ods **/
  created() {
    this.getLists();
  }
}
